import { useEffect, useState } from "react";
import wabysLogo from "../../assets/wabys.png";
import pvtdLogo from "../../assets/pvtd.png";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faMoon, faSignOutAlt, faSun, faUserGraduate } from "@fortawesome/free-solid-svg-icons";
import { useTheme } from "context/ThemeContext";
import ParentOverviewTab from "components/parent/ParentOverviewTab";
import { PARENT_TABS } from "constants/constants";
import ParentAttendanceTab from "components/parent/ParentAttendanceTab";
import ParentGradesTab from "components/parent/ParentGradesTab";
import ParentEvaluationsTab from "components/parent/ParentEvaluationsTab";
import ParentBehaviorsTab from "components/parent/ParentBehaviorsTab";
import ParentNotesTab from "components/parent/ParentNotesTab";
import ParentNewsTab from "components/parent/ParentNewsTab";
import ParentPointsTab from "components/parent/ParentPointsTab";
import ParentTeachersTab from "components/parent/ParentTeachersTab";
import { useAuth } from "context/AuthContext";
import { fetchWisdomRelatedSchools, fetchWisdomRelatedStudents } from "services/wisdom/wisdomData";
import LoadingScreen from "components/LoadingScreen";
import ModelNaviagtionSideBar from "components/ui/ModelNavigationSideBar";

const ParentDashboard = () => {
    const { darkMode, toggleDarkMode } = useTheme();
    const [activeTab, setActiveTab] = useState('overview');
    const { logout, userInfo } = useAuth();
    const [schools, setSchools] = useState([]);
    const [selectedSchool, setSelectedSchool] = useState("");
    const [students, setStudents] = useState([]);
    const [filteredStudents, setFilteredStudents] = useState([]);
    const [selectedStudent, setSelectedStudent] = useState("");
    const [loading, setLoading] = useState(true);
    const [selectedMonth, setSelectedMonth] = useState('all');

    const filterByMonth = (list, dateField = 'createdAt') => {

        if (selectedMonth === 'all') return list;

        return list.filter(item => {

            const date = new Date(item[dateField] || item.createdAt || item.date || item.behavior_date);

            return date.getMonth().toString() === selectedMonth;

        });

    };

    // fetching the required data
    useEffect(() => {
        const fetchingData = async () => {
            try {
                const [schoolsResponse, studentsResponse] =
                    await Promise.all([
                        fetchWisdomRelatedSchools(),
                        fetchWisdomRelatedStudents()
                    ]);
                setSchools(schoolsResponse);
                setStudents(studentsResponse);
                setFilteredStudents(studentsResponse);
            } catch (err) {
                console.error("API Error:", err);
            } finally {
                setLoading(false);
            }
        }

        fetchingData();
    }, [userInfo]);

    // feltering the students data based on selected school
    useEffect(() => {
        const filterStudents = () => {
            let filteringStudents;
            if (userInfo?.user_role === 'Teacher') {
                filteringStudents = students.filter(student => student.school_id === Number(userInfo?.organization_id));
            } else {
                filteringStudents = students.filter(student => selectedSchool === "" ? true : student.school_id === Number(selectedSchool));
            }
            setFilteredStudents(filteringStudents);
        }

        filterStudents();
    }, [userInfo, selectedSchool]);

    const studentId = userInfo?.organization_id === 13 || userInfo?.user_role === "Teacher" ? selectedStudent : userInfo.student?.id

    const renderTab = () => {

        switch (activeTab) {

            case 'overview': return <ParentOverviewTab studentId={studentId} onNavigate={setActiveTab} parentInfo={userInfo} />;

            case 'attendance': return <ParentAttendanceTab studentId={studentId} parentInfo={userInfo} />;

            case 'grades': return <ParentGradesTab studentId={studentId} />;

            case 'evaluations': return <ParentEvaluationsTab studentId={studentId} />;

            case 'behaviors': return <ParentBehaviorsTab studentId={studentId} />;

            case 'notes': return <ParentNotesTab studentId={studentId} />;

            case 'news': return <ParentNewsTab studentId={studentId} />;

            case 'points': return <ParentPointsTab studentId={studentId} />;

            case 'teachers': return <ParentTeachersTab studentId={studentId} />;

            default: return null;

        }

    };

    const months = [

        { v: 'all', l: 'كل الشهور' },

        { v: '0', l: 'يناير' }, { v: '1', l: 'فبراير' }, { v: '2', l: 'مارس' },

        { v: '3', l: 'أبريل' }, { v: '4', l: 'مايو' }, { v: '5', l: 'يونيو' },

        { v: '6', l: 'يوليو' }, { v: '7', l: 'أغسطس' }, { v: '8', l: 'سبتمبر' },

        { v: '9', l: 'أكتوبر' }, { v: '10', l: 'نوفمبر' }, { v: '11', l: 'ديسمبر' },

    ];

    const activeTabInfo = PARENT_TABS.find(t => t.id === activeTab);

    if (loading) return <LoadingScreen />

    return (

        <div className="min-h-screen flex flex-col relative z-10 bg-slate-600">
            <ModelNaviagtionSideBar defaultOpen={false} />
            {/* HEADER */}

            <header className="bg-white/80 dark:bg-black/40 backdrop-blur-xl border-b border-gray-200 dark:border-white/10 px-8 py-4 flex items-center justify-between sticky top-0 z-50 transition-colors duration-300">

                <div className="flex items-center gap-4">

                    <img src={wabysLogo} alt="WABYS Logo" className="h-10 w-10 object-contain drop-shadow-md bg-white rounded-full p-1" />

                    <img src={pvtdLogo} alt="PVTD Logo" className="h-10 w-auto object-contain drop-shadow-md rounded-lg p-0.5" />

                    <span className="text-2xl font-black bg-clip-text text-transparent bg-gradient-to-r from-blue-500 to-purple-600 tracking-wider hidden sm:inline-block">WISDOM</span>

                </div>

                {userInfo?.organization_id === 13 || userInfo?.user_role === 'Teacher' ?
                    <div className="flex gap-2" dir="rtl">
                        {userInfo?.user_role === 'Teacher' ?
                            <div>{userInfo?.organization_id}</div> :
                            <select
                                value={selectedSchool}
                                onChange={(e) => setSelectedSchool(e.target.value)}
                            >
                                <option value="">اختر مدرسة</option>
                                {schools.map((school) => (
                                    <option key={school.id} value={school.id}>
                                        {school.name}
                                    </option>
                                ))}
                            </select>
                        }

                        <select
                            value={selectedStudent}
                            onChange={(e) => setSelectedStudent(e.target.value)}
                        >
                            <option value="">اختر طالب</option>
                            {filteredStudents.map((student) => (
                                <option key={student.id} value={student.id}>
                                    {student.first_name} {student.middle_name} {student.last_name}
                                </option>
                            ))}
                        </select>
                    </div> :
                    <div className="flex items-center gap-6">

                        <div className="flex items-center gap-4 bg-white/40 dark:bg-black/20 p-1.5 pr-6 rounded-full border border-gray-200/50 dark:border-white/10 shadow-sm backdrop-blur-md transition-all hover:bg-white/60 dark:hover:bg-white/5">

                            <div className="flex flex-col items-end">

                                <span className="font-bold text-gray-800 dark:text-white text-sm tracking-wide">{userInfo.student?.name}</span>

                                <span className="text-xs text-gray-500 dark:text-gray-400 font-medium">

                                    {userInfo.student.school?.name} {userInfo.student?.class && ` | ${userInfo.student.class.name}`}

                                </span>

                            </div>

                            <div className="w-11 h-11 rounded-full bg-gradient-to-tr from-blue-500 to-purple-600 p-0.5 shadow-md">

                                <div className="w-full h-full bg-white dark:bg-gray-900 rounded-full flex items-center justify-center text-lg text-blue-500 dark:text-blue-400">

                                    <FontAwesomeIcon icon={faUserGraduate} />

                                </div>

                            </div>

                        </div>

                    </div>
                }

                <div className="flex items-center gap-3">

                    {/* <button onClick={toggleDarkMode} className="p-3 rounded-xl bg-gray-100 dark:bg-white/10 text-gray-600 dark:text-gray-300 hover:bg-gray-200 dark:hover:bg-white/20 transition-colors shadow-sm focus:outline-none" title="تبديل المظهر">

                        <FontAwesomeIcon icon={darkMode ? faSun : faMoon} className="text-lg" />

                    </button> */}

                    <button id="parent-logout-btn" onClick={logout} className="p-3 sm:px-5 sm:py-3 rounded-xl bg-red-500/10 text-red-600 dark:text-red-400 hover:bg-red-500/20 border border-red-500/20 transition-all font-bold flex items-center gap-2 shadow-sm focus:outline-none">

                        <span className="hidden sm:inline">تسجيل الخروج</span>

                        <FontAwesomeIcon icon={faSignOutAlt} />

                    </button>

                </div>

            </header>



            {/* BODY */}

            <div className="flex flex-1 overflow-hidden relative z-10">

                {/* SIDEBAR */}

                <nav className="w-64 flex-shrink-0 bg-white/60 dark:bg-black/20 backdrop-blur-md border-l border-gray-200 dark:border-white/10 overflow-y-auto py-8 px-4 flex flex-col gap-2 transition-colors duration-300 shadow-[inset_-10px_0_20px_rgba(0,0,0,0.02)] dark:shadow-[inset_-10px_0_20px_rgba(0,0,0,0.2)]">

                    <div className="text-xs font-black text-gray-400 dark:text-gray-500 mb-4 px-4 uppercase tracking-widest menu-label">القائمة الرئيسية</div>

                    {PARENT_TABS.map(tab => {

                        const active = activeTab === tab.id;

                        return (

                            <button

                                key={tab.id}

                                id={`parent-tab-${tab.id}`}

                                onClick={() => setActiveTab(tab.id)}

                                className={`w-full flex items-center gap-4 px-5 py-4 rounded-2xl transition-all duration-300 font-bold focus:outline-none ${active

                                    ? 'bg-gradient-to-r from-blue-500/10 to-indigo-500/10 dark:from-blue-500/20 dark:to-indigo-500/20 text-blue-600 dark:text-blue-400 shadow-sm border border-blue-200 dark:border-blue-500/30 translate-x-[-4px]'

                                    : 'text-gray-600 dark:text-gray-400 hover:bg-gray-100 dark:hover:bg-white/5 hover:text-gray-900 dark:hover:text-white border border-transparent'

                                    }`}

                            >

                                <span className="text-xl">{tab.icon}</span>

                                <span>{tab.label}</span>

                                {active && <div className="absolute right-0 w-1.5 h-8 bg-blue-500 rounded-l-full"></div>}

                            </button>

                        );

                    })}

                </nav>



                {/* CONTENT */}

                <main className="flex-1 p-6 md:p-10 overflow-y-auto w-full relative z-10 scrollbar-hide">

                    <div className="max-w-6xl mx-auto">

                        <div className="flex justify-between mb-8">
                            {/* Page Title and Icon */}
                            <div className="flex items-center gap-4">
                                <div className="w-14 h-14 rounded-2xl bg-white dark:bg-white/10 shadow-sm border border-gray-200 dark:border-white/10 flex items-center justify-center text-2xl">
                                    {activeTabInfo?.icon}
                                </div>
                                <h2 className="text-3xl font-black text-gray-800 dark:text-white drop-shadow-sm">{activeTabInfo?.label}</h2>
                            </div>
                            {/* Month Navigator */}
                            {activeTab === 'overview' && <div className="flex items-center gap-2 bg-white/50 dark:bg-black/20 p-1 rounded-xl border border-gray-200 dark:border-white/10 shadow-sm">

                                <span className="px-3 text-sm font-bold text-gray-600 dark:text-gray-400">📅 الشهر:</span>

                                <select

                                    value={selectedMonth}

                                    onChange={(e) => setSelectedMonth(e.target.value)}

                                    className="bg-transparent text-sm font-bold text-watomsBlue dark:text-blue-400 focus:outline-none cursor-pointer p-2"

                                >

                                    {months.map(m => <option key={m.v} value={m.v} className="dark:bg-gray-900 text-gray-900 dark:text-white">{m.l}</option>)}

                                </select>

                            </div>}

                            {activeTab === 'overview' && <div>
                                <h3 className="text-xl text-center font-bold text-gray-800 dark:text-white">نظرة عامة على الأداء</h3>
                                <p className="text-sm text-gray-500 dark:text-gray-400">ملخص شامل لمستوى الطالب في جميع الأقسام</p>
                            </div>}
                        </div>

                        {renderTab()}

                    </div>

                </main>

            </div>

        </div>

    );
}

export default ParentDashboard;